import { Fragment } from 'react'

import { useDateLocale, useTimeZone } from '../../../../../hooks'
import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowContextActions,
  useTableRowActions,
} from '../../../../Table'

import { renderImportRunCell } from './IntegrationsImportLogRow.utils'

import * as styles from './IntegrationsImportLogRow.module.css'

function IntegrationsImportLogRow({
  actionLeft,
  columns,
  emptyColumnSize,
  focusedRow,
  getActions,
  isResizing,
  item,
  resizingColumn,
  showCellBorder,
  ...restProps
}) {
  const locale = useDateLocale()
  const timezone = useTimeZone()

  const {
    handleCallAction,
    handleClick,
    handleMouseDown,
    handleMouseEnter,
    handleMouseLeave,
  } = useTableRowActions({ item, ...restProps })

  return (
    <div
      {...getTableRowQaProps()}
      className={styles.IntegrationsImportLogRow}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderImportRunCell({
            blockedClassName: styles.blocked,
            heldClassName: styles.held,
            isActive: column.name === resizingColumn,
            isResizing,
            item,
            locale,
            name: column.name,
            showCellBorder,
            timezone,
            width: column.width,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
      {getActions?.(item)?.length > 0 ? (
        <TableRowContextActions
          actionLeft={actionLeft}
          focusedRow={focusedRow}
          getActions={getActions}
          item={item}
          onCallAction={handleCallAction}
        />
      ) : null}
    </div>
  )
}

export default IntegrationsImportLogRow
